/* eslint-disable jsx-a11y/anchor-is-valid */
import {yupResolver} from '@hookform/resolvers/yup'
import moment from 'moment'
import {FC, useEffect, useState} from 'react'
import {FormProvider, useForm} from 'react-hook-form'
import {KTCard} from '../../../../../../../_metronic/helpers'
import {Button, ButtonWrapper} from '../../../../../components/UI/Button'
import {InputDateWrapper, SelectWrapper} from '../../../../../components/UI/Form/Input'
import {useKhipu} from '../../../../../hooks/useKhipu'
import {SelectOption} from '../../../../../models/utility.model'
import {retiredGuestFilterSchema} from '../../../../../util/validationHoteleria'
import {useCentralServices} from '../../../hooks/useCentralServices'
import {
  RatioCheckinOutCompanyColumn,
  RatioCheckinOutData,
  RatioCheckinOutEnterpriseColumn,
} from '../../../models/reports.model'
import {getRatioCheckInOutService} from '../../../services/ratio.service'
import {RetiredGuestColumnModel, RetiredGuestFilterModel} from '../../guests/model/retired.model'
import {TableRetiredGuestsWrapper} from '../tables/TableRetiredGuests'
import {getRetiredGuestsService} from '../../../services/booking.service'
// import {TableReportRatioCheckinoutWrapper} from './Tables/TableReportRatioCheckinout'
// import {TableReportRatioCheckinoutCompanyWrapper} from './Tables/TableReportRatioCheckinoutCompany'
// import {TableReportRatioCheckinoutEnterpriseWrapper} from './Tables/TableReportRatioCheckinoutEnterprise'

const FormRetiredGuests: FC = () => {
  const methods = useForm<RetiredGuestFilterModel>({
    resolver: yupResolver(retiredGuestFilterSchema),
    defaultValues: {
      CompaniaId: '',
      ClienteId: '',
      SiteId: '',
      CampamentoId: '',
      FechaCheckOutFin: moment().format('YYYY-MM-DD'),
      FechaCheckOutIni: moment().format('YYYY-MM-DD'),
    },
  })
  const {
    control,
    formState: {errors},
    register,
    setValue,
    handleSubmit,
    setError,
    watch,
    reset,
  } = methods
  const [compani, setCompany] = useState<SelectOption[]>([])
  const [client, setClient] = useState<SelectOption[]>([])
  const [site, setSite] = useState<SelectOption[]>([])
  const [camp, setCamp] = useState<SelectOption[]>([])
  const [loading, setLoading] = useState<boolean>(false)
  const [dataRetiredGuests, setDataRetiredGuests] = useState<RetiredGuestColumnModel[]>([])
  const [total, setTotal] = useState<number>(0)

  const {searchValues} = useKhipu()

  const {getCompanies, getClients, getSites, getCamps} = useCentralServices()
  ///
  ///

  const getCompaniesFn = async () => {
    const data = await getCompanies({isCombo: true}, 1)
    if (data.length === 1) {
      setValue('CompaniaId', data[0].value as string)
      setError('CompaniaId', {})
      await getClientsFn(data[0].value as string)
    }
    // const allData = [{value: '', label: 'TODOS'}, ...data]
    setCompany(data)
  }

  const getClientsFn = async (companyId: string) => {
    const data = await getClients({isCombo: true, companiaId: companyId}, 1)
    if (data.length === 1) {
      setValue('ClienteId', data[0].value as string)
      setError('ClienteId', {})

      await getSitesFn(data[0].value as string)
    }
    // const allData = [{value: '', label: 'TODOS'}, ...data]
    setClient(data)
  }

  const getSitesFn = async (clientId: string) => {
    const data = await getSites({isCombo: true, clienteId: clientId}, 1)
    if (data.length === 1) {
      setValue('SiteId', data[0].value as string)
      setError('SiteId', {})
      await getCampsFn(data[0].value as string)
    }
    // const allData = [{value: '', label: 'TODOS'}, ...data]
    setSite(data)
  }

  const getCampsFn = async (siteId: string) => {
    const data = await getCamps({isCombo: true, siteId: siteId}, 1)
    if (data.length === 1) {
      setValue('CampamentoId', data[0].value as string)
      setError('CampamentoId', {})
    }
    // const allData = [{value: '', label: 'TODOS'}, ...data]
    setCamp(data)
  }

  useEffect(() => {
    getCompaniesFn()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getRetiredGuests = async (datafilter: any = {}) => {
    try {
      if (
        !watch('CampamentoId') &&
        !watch('ClienteId') &&
        !watch('SiteId') &&
        !watch('CompaniaId')
      ) {
        return
      }
      setLoading(true)
      const obj = {...(watch() as any)}
      //   for (var clave in obj) {
      //     if (obj.hasOwnProperty(clave)) {
      //       if (obj[clave] === '') {
      //         obj[clave] = null
      //       }
      //     }
      //   }
      const formValue = {pageNumber: 1, size: 10, ...obj, ...searchValues, ...datafilter}
      const {data: response} = await getRetiredGuestsService(formValue)
      if (!response.error) {
        setDataRetiredGuests(response.data)
        setTotal(response.total)
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const onSubmit = (dataForm: any) => {
    getRetiredGuests()
  }

  const handleFilterClient = (e: any) => {
    let value = e.value
    setValue('ClienteId', '')
    setValue('SiteId', '')
    setValue('CampamentoId', '')
    getClientsFn(value)
    setValue('CompaniaId', value)
    setError('CompaniaId', {})
    setClient([])
    setSite([])
    setCamp([])
  }

  const handleFilterSite = (e: any) => {
    let value = e.value
    setValue('SiteId', '')
    setValue('CampamentoId', '')
    getSitesFn(value)
    setValue('ClienteId', value)
    setError('ClienteId', {})
    setSite([])
    setCamp([])
  }

  const handleFilterCamp = (e: any) => {
    let value = e.value
    setValue('CampamentoId', '')
    getCampsFn(value)
    setValue('SiteId', value)
    setError('SiteId', {})
    setCamp([])
  }

  const handleClear = () => {
    reset()
    setClient([])
    setSite([])
    setCamp([])
  }

  return (
    <>
      <KTCard shadow className='m-5'>
        <div className='p-6'>
          <FormProvider {...methods}>
            <form className='m-2'>
              <div className='row'>
                <div className='mb-2 col-sm-12 col-lg-3'>
                  <SelectWrapper
                    labelText='Compañía'
                    name='CompaniaId'
                    data={compani}
                    onChangeValue={handleFilterClient}
                  />
                </div>
                <div className='mb-2 col-sm-12 col-lg-3'>
                  <SelectWrapper
                    labelText='Cliente'
                    name='ClienteId'
                    data={client}
                    onChangeValue={handleFilterSite}
                  />
                </div>
                <div className='mb-2 col-sm-12 col-lg-3'>
                  <SelectWrapper
                    labelText='Site'
                    name='SiteId'
                    data={site}
                    onChangeValue={handleFilterCamp}
                  />
                </div>
                <div className='mb-2 col-sm-12 col-lg-3'>
                  <SelectWrapper labelText='Campamento' name='CampamentoId' data={camp} />
                </div>
                <div className='mb-2 col-sm-12 col-lg-3'>
                  <InputDateWrapper
                    labelText='Fecha Inicio de CheckOut'
                    name='FechaCheckOutIni'
                    // minValue={moment().format('YYYY-MM-DD')}
                  />
                </div>
                <div className='mb-2 col-sm-12 col-lg-3'>
                  <InputDateWrapper
                    labelText='Fecha Fin de CheckOut'
                    name='FechaCheckOutFin'
                    // minValue={moment().format('YYYY-MM-DD')}
                  />
                </div>
              </div>
              {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
              <ButtonWrapper className={'sdx-white-bg'}>
                <Button label='Buscar' onClick={handleSubmit(onSubmit)} />
                <Button label='Limpiar' onClick={handleClear} />
                {/* <Button label='Exportar' onClick={handleExport} /> */}
              </ButtonWrapper>
            </form>
          </FormProvider>
        </div>
        <TableRetiredGuestsWrapper
          datos={dataRetiredGuests}
          loading={loading}
          getRetiredGuests={getRetiredGuests}
          total={total}
        />
      </KTCard>
    </>
  )
}

export {FormRetiredGuests}
